import React, { ReactElement, useState } from 'react'
import { DatePicker, HeaderPage, Input, Select } from '@components/atoms'
import { ContainerPesquisa } from '@pages/style'
import { useForm } from 'react-hook-form'
import { Button, Col, Row, Typography, Table, Spin, Drawer } from 'antd'
import { Content } from 'antd/lib/layout/layout'
import { SearchOutlined } from '@ant-design/icons'

const data = [
  {
    PROMOCAO: '1',
    DESCPRODUTO: 'MousePad Redragon',
    UNIDADE: '100',
    CUSTOAQUISICAO: 'R$ 12,99',
    PRECOVENDA: 'R$ 90, 00',
    PRECOSUGERIDO: 'R$ 100,00',
    PRECOPROMOCAO: 'R$ 112,99',
    QTDEESTOQUE: '10.000',
    DATAINICIO: '21/02/2004',
    DATAFINAL: '10/01/2021',
    STATUS: 'Possuí',
  },
  {
    PROMOCAO: '2',
    DESCPRODUTO: 'MousePad Redragon',
    UNIDADE: '100',
    CUSTOAQUISICAO: 'R$ 12,99',
    PRECOVENDA: 'R$ 90, 00',
    PRECOSUGERIDO: 'R$ 100,00',
    PRECOPROMOCAO: 'R$ 112,99',
    QTDEESTOQUE: '10.000',
    DATAINICIO: '21/02/2004',
    DATAFINAL: '10/01/2021',
    STATUS: 'Possuí',
  },
  {
    PROMOCAO: '3',
    DESCPRODUTO: 'MousePad Redragon',
    UNIDADE: '100',
    CUSTOAQUISICAO: 'R$ 12,99',
    PRECOVENDA: 'R$ 90, 00',
    PRECOSUGERIDO: 'R$ 100,00',
    PRECOPROMOCAO: 'R$ 112,99',
    QTDEESTOQUE: '10.000',
    DATAINICIO: '21/02/2004',
    DATAFINAL: '10/01/2021',
    STATUS: 'Possuí',
  },
  {
    PROMOCAO: '4',
    DESCPRODUTO: 'MousePad Redragon',
    UNIDADE: '100',
    CUSTOAQUISICAO: 'R$ 12,99',
    PRECOVENDA: 'R$ 90, 00',
    PRECOSUGERIDO: 'R$ 100,00',
    PRECOPROMOCAO: 'R$ 112,99',
    QTDEESTOQUE: '10.000',
    DATAINICIO: '21/02/2004',
    DATAFINAL: '10/01/2021',
    STATUS: 'Possuí',
  },
]

export default function ProdutosPromocao(): ReactElement {
  const { control, watch, reset } = useForm()
  const { Option } = Select
  // const methods = useForm()
  const allFields = /* methods. */ watch()
  const { Column } = Table
  const [spinning, setSpinning] = useState(false)
  const [visible, setVisible] = useState(false)

  const showDrawer = () => {
    setVisible(true)
  }

  const onClose = () => {
    setVisible(false)
  }

  const limparFiltros = () => {
    reset()
  }

  const filtrarResultados = (/* props: {
    agrupamento: string
    cliente: string
    dtinicio: string
    dtfinal: string
    valor: string
  } */) => {
    /* data.filter((value) => {
      setSpinning(true)
      const dataFilter = value.AGRUPAMENTO === props.agrupamento
      console.log(value.AGRUPAMENTO === props.agrupamento)
      setSpinning(false)
      return dataFilter
    }) */
  }

  return (
    <ContainerPesquisa>
      <Content style={{ padding: 24 }}>
        <Spin tip='Filtrando...' spinning={spinning}>
          <HeaderPage
            title='Produtos em Promoção'
            extra={[
              <Button
                key='buttonSearch'
                className='buttonSearch'
                onClick={() => showDrawer()}
              >
                <p>Filtrar</p>
                <SearchOutlined key='iconSearch' className='iconSearch' />
              </Button>,
            ]}
          />
          <Table dataSource={data}>
            <Column title='Promoção' dataIndex={'PROMOCAO'} />
            <Column title='Descrição do Produto' dataIndex={'DESCPRODUTO'} />
            <Column title='Und' dataIndex={'UNIDADE'} />
            <Column title='Custo Aquisição' dataIndex={'CUSTOAQUISICAO'} />
            <Column title='Preço Venda' dataIndex={'PRECOVENDA'} />
            <Column title='Preço Sugerido' dataIndex={'PRECOSUGERIDO'} />
            <Column title='Preço Promoção' dataIndex={'PRECOPROMOCAO'} />
            <Column title='Qtde Estoque' dataIndex={'QTDEESTOQUE'} />
            <Column title='Data Início' dataIndex={'DATAINICIO'} />
            <Column title='Data Final' dataIndex={'DATAFINAL'} />
            <Column title='Status' dataIndex={'STATUS'} />
          </Table>
        </Spin>
      </Content>
      <Drawer
        onClose={onClose}
        visible={visible}
        title='Filtros'
        style={{ marginTop: '4rem' }}
      >
        <Row key='mainRow'>
          <Col span={24}>
            <Typography.Title level={5}>Descrição do Produto</Typography.Title>
            <Input
              control={control}
              name='DESCPRODUTO'
              placeholder='Descrição do Produto'
            />
          </Col>
          <Col span={allFields.GRUPO === 'Específico' ? 7 : 24}>
            <Typography.Title level={5}>Grupo</Typography.Title>
            <Select
              control={control}
              allowClear
              defaultValue='Todos'
              name='GRUPO'
              placeholder='Grupo'
            >
              <Option value='Todos'>Todos</Option>
              <Option value='Específico'>Específico</Option>
            </Select>
          </Col>
          {allFields.GRUPO === 'Específico' ? (
            <Col span={17}>
              <Typography.Title level={5}>Grupo Específico</Typography.Title>
              <Select
                control={control}
                allowClear
                name='GRUPOESPEC'
                placeholder='Grupo Específico'
              >
                <Option value='Grupo 1'>Grupo 1</Option>
                <Option value='Grupo 2'>Grupo 2</Option>
              </Select>
            </Col>
          ) : null}
          <Col span={allFields.SUBGRUPO === 'Específico' ? 7 : 24}>
            <Typography.Title level={5}>SubGrupo</Typography.Title>
            <Select
              control={control}
              allowClear
              defaultValue='Todos'
              name='SUBGRUPO'
              placeholder='SubGrupo'
            >
              <Option value='Todos'>Todos</Option>
              <Option value='Específico'>Específico</Option>
            </Select>
          </Col>
          {allFields.SUBGRUPO === 'Específico' ? (
            <Col span={17}>
              <Typography.Title level={5}>SubGrupo Específico</Typography.Title>
              <Select
                control={control}
                allowClear
                name='SUBGRUPOESPEC'
                placeholder='SubGrupo Específico'
              >
                <Option value='SubGrupo 1'>SubGrupo 1</Option>
                <Option value='SubGrupo 2'>SubGrupo 2</Option>
              </Select>
            </Col>
          ) : null}
          <Col span={allFields.MARCA === 'Específica' ? 7 : 24}>
            <Typography.Title level={5}>Marca</Typography.Title>
            <Select
              control={control}
              allowClear
              defaultValue='Todos'
              name='MARCA'
              placeholder='Marca'
            >
              <Option value='Todos'>Todos</Option>
              <Option value='Específica'>Específica</Option>
            </Select>
          </Col>
          {allFields.MARCA === 'Específica' ? (
            <Col span={17}>
              <Typography.Title level={5}>Marca Específica</Typography.Title>
              <Select
                control={control}
                allowClear
                name='MARCAESPEC'
                placeholder='Marca Específica'
              >
                <Option value='Marca 1'>Marca 1</Option>
                <Option value='Marca 2'>Marca 2</Option>
              </Select>
            </Col>
          ) : null}
          <Col span={allFields.CLASSE === 'Específica' ? 7 : 24}>
            <Typography.Title level={5}>Classe</Typography.Title>
            <Select
              control={control}
              allowClear
              defaultValue='Todos'
              name='CLASSE'
              placeholder='Classe'
            >
              <Option value='Todos'>Todos</Option>
              <Option value='Específica'>Específica</Option>
            </Select>
          </Col>
          {allFields.CLASSE === 'Específica' ? (
            <Col span={17}>
              <Typography.Title level={5}>Classe Específica</Typography.Title>
              <Select
                control={control}
                allowClear
                name='CLASSEESPEC'
                placeholder='Classe Específica'
              >
                <Option value='Classe 1'>Classe 1</Option>
                <Option value='Classe 2'>Classe 2</Option>
              </Select>
            </Col>
          ) : null}
          <Col span={24}>
            <Typography.Title level={5}>Período Promocional</Typography.Title>
            <Row gutter={3} align='middle'>
              <Col span={12}>
                <DatePicker name='DTINICIO' control={control} />
              </Col>
              <Col span={12}>
                <DatePicker name='DTFINAL' control={control} />
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Typography.Title level={5}>Promoção</Typography.Title>
            <Select
              control={control}
              allowClear
              name='PROMOCAO'
              placeholder='Promoção'
            >
              <Option value='Ativa'>Ativa</Option>
              <Option value='Concluída'>Concluída</Option>
              <Option value='Cancalada'>Cancalada</Option>
              <Option value='Todas'>Todas</Option>
            </Select>
          </Col>
          <Col span={24} style={{ marginTop: '1.5rem' }}>
            <Row gutter={5}>
              <Col>
                <Button
                  danger
                  type='default'
                  onClick={() => {
                    limparFiltros()
                  }}
                  style={{
                    width: 110,
                  }}
                >
                  Limpar filtro
                </Button>
              </Col>
              <Col>
                <Button
                  type='primary'
                  onClick={() => {
                    filtrarResultados(/* {
                      agrupamento: allFields.AGRUPAMENTO_ESPEC,
                      cliente: allFields.CLIENTE_ESPEC,
                      dtinicio: allFields.DTINICIO,
                      dtfinal: allFields.DTFINAL,
                      valor: allFields.VALOR,
                    } */)

                    onClose()
                  }}
                  style={{
                    width: 110,
                  }}
                >
                  Filtrar
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Drawer>
    </ContainerPesquisa>
  )
}
